import { env } from '@/shared/config/env';

/**
 * Google Analytics 4 — wylacznie dla publicznego ekranu turniejow.
 *
 * Tag ladujemy dopiero z poziomu `PublicTournamentScreenPage`, a nie w
 * `index.html`, zeby zalogowana czesc aplikacji (turnieje, konta) nie byla
 * sledzona — `index.html` jest wspolny dla wszystkich tras SPA.
 *
 * Identyfikator pomiaru jest zaszyty w kodzie tak samo jak skroty klubow
 * w `publicScreens.ts` — nie jest sekretem (i tak widac go w zrodle strony),
 * a dzieki temu deploy nie zalezy od zmiennych srodowiskowych w CI.
 */
const GA_MEASUREMENT_ID = 'G-M2VCFMCEFT';

declare global {
  interface Window {
    /** Kolejka polecen gtag — GA czyta ja po zaladowaniu wlasciwego skryptu. */
    dataLayer?: unknown[];
  }
}

/** Czy tag zostal juz wstrzykniety — ekran montuje sie tylko raz, ale na wszelki wypadek. */
let initialized = false;

/**
 * Wstrzykuje tag GA i rejestruje wejscie na ekran publiczny.
 *
 * Poza buildem produkcyjnym (dev, testy vitest) nic nie robi — lokalne
 * wejscia nie maja zaszumiac statystyk.
 */
export function initPublicScreenAnalytics(): void {
  if (!env.isProd || initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer ?? [];
  // gtag musi wpychac obiekt `arguments` (nie tablice) — tego oczekuje
  // skrypt GA; to doslowna kopia oficjalnego snippetu.
  function gtag(..._args: unknown[]) {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}
